import { render, staticRenderFns } from "./BlockVendor.vue?vue&type=template&id=10289dd1&"
import script from "./BlockVendor.vue?vue&type=script&lang=js&"
export * from "./BlockVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports